import type { SvgIconComponent } from '@mui/icons-material';
import AccountTree from '@mui/icons-material/AccountTree';
import Add from '@mui/icons-material/Add';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Dashboard from '@mui/icons-material/Dashboard';
import Description from '@mui/icons-material/Description';
import Edit from '@mui/icons-material/Edit';
import FilePresent from '@mui/icons-material/FilePresent';
import Folder from '@mui/icons-material/Folder';
import Info from '@mui/icons-material/Info';
import ManageSearch from '@mui/icons-material/ManageSearch';
import Person from '@mui/icons-material/Person';

export type PageHeaderIconVariant =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'success'
  | 'warning'
  | 'info'
  | 'inherit';

export const PAGE_HEADER_ICONS = {
  documents: FilePresent,
  dashboard: Dashboard,
  calendar: CalendarMonth,
  search: ManageSearch,
  accountTree: AccountTree,
  folder: Folder,
  description: Description,
  person: Person,
  info: Info,
  add: Add,
  edit: Edit,
} as const;

export type PageHeaderIconType = keyof typeof PAGE_HEADER_ICONS;

export function getPageHeaderIconComponent(
  type: PageHeaderIconType,
): SvgIconComponent {
  return PAGE_HEADER_ICONS[type];
}
